import React from 'react';
import { Popover } from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { renderRecordValue } from '../../../utils';
import styles from './index.module.css';
import { PatientSpecialAccommodationIcon } from '../../../assets';

export const PatientSpecialAccommodationsIcon = ({
  tooltip = 'Higher cancellations or mobility related issues', // Default tooltip content
  width = 24, // Default width
  height = 22, // Default height
  fill = '#E1F4D3', // Default fill color
  strokeColor = '#1C452B', // Outline/stroke color
  highlightFill = '#FFA500', // Warning/highlight color
  text = '', // Default text for renderRecordValue
  showText = false, // Conditional rendering for renderRecordValue
  specialNeeds = null,
  rideStatus = null,
}) => {
  const renderContent = () => (
    <div className={showText ? styles.leg : undefined}>
      <PatientSpecialAccommodationIcon fill={fill} strokeColor={strokeColor} highlightFill={highlightFill} width={width} height={height} />
      {showText && <span className={styles.ml_5}>{renderRecordValue(text)}</span>}
    </div>
  );


  if (specialNeeds) {
    tooltip = '';

    if (specialNeeds?.noShowProbability) {
      tooltip += 'Rider no-shows > 5 within 90 days\n';
    }

    if (specialNeeds?.frequentCancellations) {
      tooltip += 'Cancellations > 5 within 90 days\n';
    }

    if (specialNeeds?.lateSameDayCancellations) {
      tooltip += 'Same day cancellations > 5 within 90 days\n';
    }

    if (specialNeeds?.ageOver70) {
      tooltip += 'Rider Age > 70 \n';
    }

    if (specialNeeds?.weightOver300) {
      tooltip += 'Rider Weight > 300 lbs \n';
    }
    
    
    
    
    
  }

  return tooltip && tooltip.trim() ? (
    <Popover
      content={tooltip}
      trigger="hover"
      overlayClassName={classNames(styles.overlay)}
      getPopupContainer={(trigger) => document.body}
    >
      {renderContent()}
    </Popover>
  ) : (
    renderContent()
  );

};

PatientSpecialAccommodationsIcon.propTypes = {
  tooltip: PropTypes.string, // Tooltip content
  width: PropTypes.number, // Icon width
  height: PropTypes.number, // Icon height
  fill: PropTypes.string, // Icon fill color
  strokeColor: PropTypes.string, // Icon stroke/outline color
  highlightFill: PropTypes.string, // Icon highlight color
  text: PropTypes.string, // Text for renderRecordValue
  showText: PropTypes.bool, // Whether to show renderRecordValue
};
